export const EXHIBITION_START_TOUR_EVENT = "exhibition:startTour";
export const EXHIBITION_SKIP_TOUR_EVENT = "exhibition:skipTour";

export function requestExhibitionTour(force = false) {
  document.dispatchEvent(new CustomEvent(EXHIBITION_START_TOUR_EVENT, { detail: { force } }));
}

export function skipExhibitionTour() {
  document.dispatchEvent(new CustomEvent(EXHIBITION_SKIP_TOUR_EVENT));
}
